<script>
import {  common } from '@/mixins/common';
import { GetApiActionWithAuthorization, PostApiWithAuthorizationAction } from '../../../helpers/apiActions';

export default {
  name: 'SettingCronJobPage',
  props: {},
  data() {
    return {
        tableData: [],
        fields: [
            {
                key: "description",
                value: 'Description',
                sortable: false,
            },
            {
                key: "action",
                value: 'Action',
                sortable: false,
            }
        ],
        pagination: {
            pageSize: 50,
            page: 1,
            count: 0
        }
    }
  },
  mixins: [
    common
  ],
  methods: {
    loadPageData(params = {}) {
        let _vm = this,
            page = (typeof params.page !== 'undefined') ? params.page : _vm.pagination.page
        return GetApiActionWithAuthorization("admin/cron/get-page-data?pagination[pageSize]=" + _vm.pagination.pageSize + "&pagination[page]=" + page).then(res => {
            _vm.tableData = res.data
            _vm.pagination.count = res.count
        });
    },
    updateCronJob(data) {
        // eslint-disable-next-line
        console.log(data)
        PostApiWithAuthorizationAction("admin/cron/save-data/", data).then(() => {});
    }
  },
  computed: {},
  mounted () {
    let _vm = this
    _vm.loadPageData()
  },
  watch: {
    'pagination.page': function(page) {
      this.loadPageData({ page })
    }
  }
}
</script>
<template>
    <div class="setting-cron-job__content">
        <table
                role="table"
                aria-busy="false"
                aria-colcount="10"
                class="table b-table"
            >
            <thead
                role="rowgroup"
                class=""
                style="background-color: #74788d; color: white"
                >
                <tr role="row" class="">
                    <th
                        role="columnheader"
                        scope="col"
                        aria-colindex="1"
                        :class="[
                            field.center ? 'text-center': '',
                            'px-4'
                        ]"
                        v-for="field in fields"
                        :key="field.key"
                        >
                        <div>{{ field.value }}</div>
                    </th>
                </tr>
                </thead>
                <tbody role="rowgroup">
                <tr
                    role="row"
                    aria-rowindex="1"
                    class=""
                    v-for="data in tableData"
                    :key="data.id"
                >
                    <td
                        aria-colindex="1"
                        role="cell"
                        style="font-size: 14px">
                        {{ data.description }}
                    </td>
                    <td
                        aria-colindex="2"
                        role="cell"
                        :class="['text-center', 'px-0']">
                        <div class="mb-1">
                            <el-switch v-model="data.enable" @change="updateCronJob(data)"></el-switch>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="row">
            <div class="col">
                <div class="dataTables_paginate paging_simple_numbers">
                    <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                            v-model="pagination.page"
                            :total-rows="pagination.count"
                            :per-page="pagination.pageSize"
                            ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .el-color-picker--medium,
    .el-color-picker--medium .el-color-picker__trigger {
        width: 100%;
    }
</style>
<style scoped>
.b-table {
    background-color: rgba(0, 0, 0, 0.05);
    border: 5px solid #5b5f70;
    width: 50%
}
</style>
 